import React, { useMemo, useContext } from "react";

import Loader from "components/Loader";
import useGet from "hooks/useGet";

const CustomCommentsContext = React.createContext();

function CustomCommentsProvider({ children }) {
  const { is_loading, data, refetch } = useGet({
    path: "/custom_comments",
    query: ["custom_comments_list"],
    options: {
      refetchOnWindowFocus: false,
    },
  });

  const custom_comment_options =
    data?.map(({ id, content }) => ({
      label: content,
      value: id,
    })) || [];

  const value = useMemo(() => {
    return {
      data,
      custom_comment_options,
      refetch,
    };
    // eslint-disable-next-line
  }, [is_loading, data]);

  if (is_loading) {
    return <Loader />;
  }
  return (
    <CustomCommentsContext.Provider value={value}>
      {children}
    </CustomCommentsContext.Provider>
  );
}

const useCustomComments = () => useContext(CustomCommentsContext);
export { useCustomComments };
export default CustomCommentsProvider;
